export const QUERY_TYPES = {
  HOMEPAGE_EMBED: 'corpEmbed',
  EMBED: 'embed',
  DESKTOP: 'desktop',
};
